module.exports = __webpack_public_path__ + "static/media/aljibesCore.786ab130.mp3";